import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';


export const CardWrapper = styled.div`
  ${({ theme }) => `
    box-shadow: ${theme.shadow.level2};
    border-radius: ${theme.borderRadius.small};
    margin: 0 ${theme.spacing(1.5)} ${theme.spacing(3)};

    & > a {
      text-decoration: inherit;
      color: inherit;
    }
  `}
`;

export const CardInner = styled.div`
  ${({ theme }) => `
    padding: 0 ${theme.spacing(2)};
    color: ${theme.colors.neutrals.grey1};
    position: relative;
    border-radius: ${theme.borderRadius.small};
    overflow: hidden;
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    width: 264px;
    height: 238px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    width: 290px;
    height: 216px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 100%;
    height: 225px;
  `}
`;

export const DeveloperInfo = styled.div`
  ${({ theme }) => `
    text-align: center;
    margin-top: ${theme.spacing(1)};
  `}
`;

export const DeveloperDescription = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey3};
    margin-top: ${theme.spacing(0.5)};
  `}
`;
export const Cover = styled.div`
  ${({ theme }) => `
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    background-color: ${colorToAlpha(theme.colors.brand.main, 0.08)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    height: 92px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    height: 101px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 114px;
  `}
`;

export const LogoWrapper = styled.div<{ hasLogo: boolean; }>`
  ${({ theme, hasLogo }) => `
    border: 2px solid ${theme.colors.neutrals.white};
    border-radius: ${theme.borderRadius.tiny};
    background-color: ${hasLogo ? theme.colors.neutrals.white : theme.colors.neutrals.grey11};
    margin: ${theme.spacing(5)} auto 0;
    display: flex;
    align-items: center;
    justify-content: space-around;
    overflow: hidden;

    > img {
      width: 100%;
    }
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    height: 88px;
    width: 88px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    height: 99px;
    width: 99px;
  `}
`;

export const CoverImage = styled.div<{ src: string; }>`
  ${({ theme, src }) => `
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${theme.colors.neutrals.white};
    background-image: url("${src}");
    transform-origin: top left;
    background-size: cover;
  `}
`;
